export const importJobsInitialState = {
	entities: {},
};

export const importJobInitialState = {
	_id: undefined,
	organization: '',
	task: '',
	status: '',
	error: '',
	start: '',
	end: '',
};



// WEBPACK FOOTER //
// ./src/redux/importJobs/importJob.initialState.js